import { addListener, createListenerMiddleware } from '@reduxjs/toolkit';

import { env } from '@/config/env';
import { wsClient } from '@/lib/ws-client';
import { onFirstAuthenticated } from '@nablax/shared/stores';
import type { AppDispatch, RootState } from './store';

declare type ExtraArgument = {};
export const listenerMiddleware = createListenerMiddleware();
export const startAppListening = listenerMiddleware.startListening.withTypes<
  RootState,
  AppDispatch,
  ExtraArgument
>();
export const addAppListener = addListener.withTypes<RootState, AppDispatch>();

startAppListening({
  predicate: onFirstAuthenticated,
  effect: () => {
    wsClient.init(env.VITE_WS_SERVER_URL);
    wsClient.connect();
  },
});
